import { IGameRecord, IMatchGamePlayer, IPlayer, IPlayerGameStats } from "../types/types";
import { championIconForPlayer } from "./lolAssets";
import { computeKpPct, resolvePlayerName, sortPlayersByRole } from "./matchGameSides";

export const GRAPH_BLUE = "#3d9be9";
export const GRAPH_RED = "#e84855";

export interface PlayerGraphRow {
  id: string;
  name: string;
  championName: string;
  championIcon: string;
  teamColor: string;
  damage: number;
  gold: number;
  cs: number;
  vision: number;
  dpm: number;
  kpPct: number;
}

export const buildPlayerGraphRows = (
  game: IGameRecord,
  rosterByPuuid: Map<string, IPlayer>,
  statsByPuuid: Map<string, IPlayerGameStats>,
): { blue: PlayerGraphRow[]; red: PlayerGraphRow[] } => {
  const buildSide = (riotSide: number, teamColor: string) =>
    sortPlayersByRole((game.players ?? []).filter((player) => player.team_id === riotSide)).map(
      (player) => rowFromPlayer(player, teamColor, game, rosterByPuuid, statsByPuuid),
    );

  return {
    blue: buildSide(100, GRAPH_BLUE),
    red: buildSide(200, GRAPH_RED),
  };
};

const rowFromPlayer = (
  player: IMatchGamePlayer,
  teamColor: string,
  game: IGameRecord,
  rosterByPuuid: Map<string, IPlayer>,
  statsByPuuid: Map<string, IPlayerGameStats>,
): PlayerGraphRow => {
  const stat = statsByPuuid.get(player.puuid);
  const dpm = stat?.dpm ?? (game.duration > 0 ? Math.round(player.damage / game.duration) : 0);
  const kpPct = computeKpPct(player, game.players ?? []) ?? 0;

  return {
    id: player.puuid,
    name: resolvePlayerName(player, rosterByPuuid, statsByPuuid),
    championName: player.champion_name.trim() || "Unknown",
    championIcon: championIconForPlayer(player),
    teamColor,
    damage: player.damage,
    gold: player.gold_earned,
    cs: player.creep_score,
    vision: player.vision_score,
    dpm,
    kpPct,
  };
};
